import { type HttpEvent, type HttpHandler, type HttpInterceptor, type HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { type Observable } from 'rxjs/internal/Observable';

@Injectable()
export class LocationInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const modifiedRequest = req.clone({
      headers: req.headers.set('Reedge-Location', window.location.href),
    });

    return next.handle(modifiedRequest);
  }
}
